// @flow

// @flow

import ko from 'rgs-knockout';
import template from './templates/template.html';
import { ReactComponentModel } from './js/model';
import './js/bindings';
import type { ReactComponentParams } from './js/model';

ko.components.register('react-component-placement', {
	viewModel: {
		createViewModel: function (params: ReactComponentParams, componentInfo) {
			return new ReactComponentModel(params, componentInfo);
		},
	},
	template: template(),
});